<template>
    <div class="report">
        <el-tabs v-model="activeName" :stretch="true" @tab-click="changeTabs">
            <el-tab-pane label="订单" name="1">
                <div class="headerbox">
                    <div class="searchbox">
                        <el-input style="height:45px" clearable placeholder="请输入原始订单号" v-model="data1Params.orderId"
                            @change="searchData2">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                    <div class="filiter"><img src="@/assets/img/mobile/shaixuan.png" alt="" @click="filiterShow1 = true">
                    </div>
                </div>

                <div class="infinite-list-wrapper">
                    <div class="scrollbox" :infinite-scroll-distance="10" v-infinite-scroll="scrollData1"
                        :infinite-scroll-disabled="disabled1" infinite-scroll-immediate="false" infinite-scroll-delay="500">
                        <el-card shadow="never" class="box-card">
                            <el-table :data="tableData1" style="width: 100%">
                                <el-table-column fixed width="150" prop="orderId" show-overflow-tooltip
                                    label="原始订单号"></el-table-column>
                                <el-table-column width="100" prop="transactionDate" show-overflow-tooltip
                                    label="日期"></el-table-column>
                                <el-table-column width="100" prop="transactionAmount" show-overflow-tooltip label="分销金额">
                                </el-table-column>
                                <el-table-column width="100" prop="totalCommission" show-overflow-tooltip label="佣金金额">
                                </el-table-column>
                                <el-table-column width="100" prop="networkCommission" show-overflow-tooltip label="平台费用">
                                </el-table-column>
                                <el-table-column width="100" prop="affiliateId" show-overflow-tooltip label="联盟客ID"></el-table-column>
                                <el-table-column width="100" prop="website" show-overflow-tooltip
                                    label="联盟客姓名"></el-table-column>
                                <el-table-column width="100" prop="affiliateWebsite" show-overflow-tooltip
                                    label="推广网站"></el-table-column>
                                <el-table-column width="100" prop="tags" show-overflow-tooltip
                                    label="联盟客类型"></el-table-column>
                                <el-table-column prop="platformType" show-overflow-tooltip label="联盟平台">
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="联盟客" name="2">
                <div class="headerbox">
                    <div class="searchbox">
                        <el-input style="height:45px" clearable placeholder="搜索联盟客姓名/ID/推广网站"
                            v-model="data2Params.affliateInfo" @change="searchData1">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                    <div class="filiter"><img src="@/assets/img/mobile/shaixuan.png" alt="" @click="filiterShow2 = true">
                    </div>
                </div>

                <div class="infinite-list-wrapper">
                    <div class="scrollbox" :infinite-scroll-distance="10" v-infinite-scroll="scrollData2"
                        :infinite-scroll-disabled="disabled2" infinite-scroll-immediate="false" infinite-scroll-delay="500">
                        <el-card shadow="never" class="box-card">
                            <el-table :data="tableData2" style="width: 100%">
                                <el-table-column fixed width="100" prop="affiliateid" label="联盟客ID"></el-table-column>
                                <el-table-column width="100" prop="website" show-overflow-tooltip
                                    label="联盟客姓名"></el-table-column>
                                <el-table-column width="100" prop="affiliatewebsite" show-overflow-tooltip
                                    label="推广网站"></el-table-column>
                                <el-table-column width="100" prop="tags" show-overflow-tooltip
                                    label="联盟客类型"></el-table-column>
                                <el-table-column prop="platformtype" show-overflow-tooltip label="联盟平台">
                                </el-table-column>
                                <el-table-column width="100" prop="currentaffiliateamount" show-overflow-tooltip
                                    label="分销金额">
                                </el-table-column>
                                <el-table-column width="100" prop="amountrate" show-overflow-tooltip label="金额占比">
                                </el-table-column>
                                <el-table-column width="100" prop="ordercount" show-overflow-tooltip label="分销订单数">
                                </el-table-column>
                                <el-table-column width="100" prop="orderrate" show-overflow-tooltip label="订单数占比">
                                </el-table-column>
                                <el-table-column width="100" prop="totalcommission" show-overflow-tooltip label="佣金金额">
                                </el-table-column>
                                <el-table-column width="100" prop="networkcommission" show-overflow-tooltip label="平台费用">
                                </el-table-column>
                                <el-table-column width="100" prop="allcommission" show-overflow-tooltip label="总支出">
                                </el-table-column>

                            </el-table>
                        </el-card>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="重复订单(数据)" name="3">
                <div class="headerbox">
                    <div class="searchbox">
                        <el-input style="height:45px" clearable placeholder="请输入原始订单号" v-model="data3Params.orderId"
                            @change="searchData3">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                    <div class="filiter"><img src="@/assets/img/mobile/shaixuan.png" alt="" @click="filiterShow3 = true">
                    </div>
                </div>

                <div class="infinite-list-wrapper">
                    <div class="scrollbox" :infinite-scroll-distance="10" v-infinite-scroll="scrollData3"
                        :infinite-scroll-disabled="disabled3" infinite-scroll-immediate="false" infinite-scroll-delay="500">
                        <el-card shadow="never" class="box-card">
                            <el-table :data="tableData3" style="width: 100%" :span-method="objectSpanMethod">
                                <el-table-column width="100" show-overflow-tooltip fixed prop="orderid"
                                    label="订单号"></el-table-column>
                                <el-table-column width="100" show-overflow-tooltip prop="transdate"
                                    label="时间"></el-table-column>
                                <el-table-column width="100" show-overflow-tooltip prop="affiliateid"
                                    label="联盟客ID"></el-table-column>
                                <el-table-column width="100" prop="website" show-overflow-tooltip label="推广网站">
                                </el-table-column>
                                <el-table-column width="100" prop="organization" show-overflow-tooltip label="联盟客姓名">
                                </el-table-column>
                                <el-table-column width="100" show-overflow-tooltip prop="transamount" label="重复订单分销金额">
                                </el-table-column>
                                <el-table-column width="100" prop="tags" label="联盟客类型" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column width="100" show-overflow-tooltip prop="platformtype"
                                    label="联盟平台"></el-table-column>
                            </el-table>
                        </el-card>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="重复订单(联盟客)" name="4">
                <div class="headerbox">
                    <div class="searchbox">
                        <el-input style="height:45px" clearable placeholder="搜索联盟客姓名/ID/推广网站"
                            v-model="data4Params.affliateInfo" @change="searchData4">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                    <div class="filiter"><img src="@/assets/img/mobile/shaixuan.png" alt="" @click="filiterShow4 = true">
                    </div>
                </div>

                <div class="infinite-list-wrapper">
                    <div class="scrollbox" :infinite-scroll-distance="10" v-infinite-scroll="scrollData4"
                        :infinite-scroll-disabled="disabled4" infinite-scroll-immediate="false" infinite-scroll-delay="500">
                        <el-card shadow="never" class="box-card">
                            <el-table :data="tableData4" style="width: 100%">
                                <el-table-column fixed width="100" prop="affiliateid" show-overflow-tooltip
                                    label="联盟客ID"></el-table-column>
                                <el-table-column width="100" prop="organization" show-overflow-tooltip label="联盟客姓名">
                                </el-table-column>
                                <el-table-column width="100" prop="website" show-overflow-tooltip label="推广网站">
                                </el-table-column>
                                <el-table-column width="100" prop="ordercount" label="重复订单数"
                                    show-overflow-tooltip></el-table-column>
                                <el-table-column width="100" prop="transamountsum" show-overflow-tooltip label="重复订单分销金额">
                                </el-table-column>
                                <el-table-column width="100" prop="platformtype" show-overflow-tooltip
                                    label="联盟平台"></el-table-column>
                                <el-table-column width="100" prop="tags" show-overflow-tooltip label="联盟客类型">
                                </el-table-column>
                                <el-table-column width="100" prop="orderids" show-overflow-tooltip label="订单号">
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>


        <el-drawer :visible.sync="filiterShow1" :with-header="false" size="65%" :modal="false">
            <div class="myfiliter">
                <div class="title">
                    开始日期
                </div>
                <el-date-picker v-model="data1Params.startDate" type="date" value-format="yyyy-MM-dd" placeholder="选择开始日期"
                    style="width: 100%;height:40px;margin-bottom:8px">
                </el-date-picker>
                <div class="title">
                    结束日期
                </div>
                <el-date-picker v-model="data1Params.endDate" type="date" value-format="yyyy-MM-dd" placeholder="选择结束日期"
                    style="width: 100%;height:40px;margin-bottom:8px">
                </el-date-picker>
                <div class="title">
                    联盟平台
                </div>
                <el-select v-model="data1Params.platformType" filterable placeholder="请选择"
                    style="height:40px;margin-bottom:8px">
                    <el-option v-for="item in platformTypeList" :key="item.channelType" :label="item.channelTypeValue"
                        :value="item.channelTypeValue">
                    </el-option>
                </el-select>

                <div class="footer">
                    <el-row :gutter="8">
                        <el-col :span="12">
                            <div class="reset"> <el-button type="primary" style="width:100%"
                                    @click="resetFiliter1">重置</el-button>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="submit"> <el-button type="primary" style="width:100%"
                                    @click="searchData1">确定</el-button></div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-drawer>
        <el-drawer :visible.sync="filiterShow2" :with-header="false" size="65%" :modal="false">
            <div class="myfiliter">
                <div class="title">
                    开始日期
                </div>
                <el-date-picker v-model="data2Params.startDate" type="date" value-format="yyyy-MM-dd" placeholder="选择开始日期"
                    style="width: 100%;height:40px;margin-bottom:8px">
                </el-date-picker>
                <div class="title">
                    结束日期
                </div>
                <el-date-picker v-model="data2Params.endDate" type="date" value-format="yyyy-MM-dd" placeholder="选择结束日期"
                    style="width: 100%;height:40px;margin-bottom:8px">
                </el-date-picker>
                <div class="title">
                    联盟平台
                </div>
                <el-select v-model="data2Params.platformType" filterable placeholder="请选择"
                    style="height:40px;margin-bottom:8px">
                    <el-option v-for="item in platformTypeList" :key="item.channelType" :label="item.channelTypeValue"
                        :value="item.channelTypeValue">
                    </el-option>
                </el-select>

                <div class="footer">
                    <el-row :gutter="8">
                        <el-col :span="12">
                            <div class="reset"> <el-button type="primary" style="width:100%"
                                    @click="resetFiliter2">重置</el-button>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="submit"> <el-button type="primary" style="width:100%"
                                    @click="searchData2">确定</el-button></div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-drawer>
        <el-drawer :visible.sync="filiterShow3" :with-header="false" size="65%" :modal="false">
            <div class="myfiliter">
                <div class="title">
                    开始日期
                </div>
                <el-date-picker v-model="data3Params.startDate" type="date" value-format="yyyy-MM-dd" placeholder="选择开始日期"
                    style="width: 100%;height:40px;margin-bottom:8px">
                </el-date-picker>
                <div class="title">
                    结束日期
                </div>
                <el-date-picker v-model="data3Params.endDate" type="date" value-format="yyyy-MM-dd" placeholder="选择结束日期"
                    style="width: 100%;height:40px;margin-bottom:8px">
                </el-date-picker>

                <div class="footer">
                    <el-row :gutter="8">
                        <el-col :span="12">
                            <div class="reset"> <el-button type="primary" style="width:100%"
                                    @click="resetFiliter3">重置</el-button>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="submit"> <el-button type="primary" style="width:100%"
                                    @click="searchData3">确定</el-button></div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-drawer>
        <el-drawer :visible.sync="filiterShow4" :with-header="false" size="65%" :modal="false">
            <div class="myfiliter">
                <div class="title">
                    开始日期
                </div>
                <el-date-picker v-model="data4Params.startDate" type="date" value-format="yyyy-MM-dd" placeholder="选择开始日期"
                    style="width: 100%;height:40px;margin-bottom:8px">
                </el-date-picker>
                <div class="title">
                    结束日期
                </div>
                <el-date-picker v-model="data4Params.endDate" type="date" value-format="yyyy-MM-dd" placeholder="选择结束日期"
                    style="width: 100%;height:40px;margin-bottom:8px">
                </el-date-picker>


                <div class="footer">
                    <el-row :gutter="8">
                        <el-col :span="12">
                            <div class="reset"> <el-button type="primary" style="width:100%"
                                    @click="resetFiliter4">重置</el-button>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="submit"> <el-button type="primary" style="width:100%"
                                    @click="searchData4">确定</el-button></div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import { QUERYORDERDETAILLIST, QUERYAFFILIATEDETAILLIST, QUERYREPEATDETAILLIST, QUERYREPEATBDETAILLIST, HASPLATFORMLIST } from '@/api/platform'
export default {
    data() {
        return {
            activeName: "1",
            platformTypeList: [],
            data1Params: {
                currentPage: 1,
                size: 20,
                orderId: '',
                platformType: '',
                startDate: null,
                endDate: null,
                sort: ''
            },
            data2Params: {
                affliateInfo: '',
                platformType: '',
                startDate: null,
                endDate: null,
                currentPage: 1, // 当前页码
                size: 20,
                sort: '',
            },
            data3Params: {
                orderId: '',
                startDate: null,
                endDate: null,
                currentPage: 1, // 当前页码
                size: 20,
                sort: '',
            },
            data4Params: {
                affliateInfo: '',
                startDate: null,
                endDate: null,
                currentPage: 1,
                size: 20,
                sort: '',
                platformType: '',
            },
            totalpages1: null,
            totalpages2: null,
            totalpages3: null,
            totalpages4: null,
            loading1: false,
            loading2: false,
            loading3: false,
            loading4: false,
            filiterShow1: false,
            filiterShow2: false,
            filiterShow3: false,
            filiterShow4: false,
            tableData1: [],
            tableData2: [],
            tableData3: [],
            tableData4: [],
        }
    },
    computed: {
        noMore1() {
            return this.totalpages1 == this.data1Params.currentPage
        },
        disabled1() {
            return this.loading1 || (this.totalpages1 == this.data1Params.currentPage)
        },
        noMore2() {
            return this.totalpages2 == this.data2Params.currentPage
        },
        disabled2() {
            return this.loading2 || (this.totalpages2 == this.data2Params.currentPage)
        },
        noMore3() {
            return this.totalpages3 == this.data3Params.currentPage
        },
        disabled3() {
            return this.loading3 || (this.totalpages3 == this.data3Params.currentPage)
        },
        noMore4() {
            return this.totalpages4 == this.data4Params.currentPage
        },
        disabled4() {
            return this.loading4 || (this.totalpages4 == this.data4Params.currentPage)
        }
    },
    created() {
        this.hasPlatformList()
        this.queryData1()
    },
    mounted() {

    },
    methods: {
        hasPlatformList() {
            HASPLATFORMLIST().then(res => {
                if (res.data.body) {
                    this.platformTypeList = res.data.body
                }
            })
        },
        searchData1() {
            this.queryData1()
            this.filiterShow1 = false
        },
        searchData2() {
            this.queryData2()
            this.filiterShow2 = false
        },
        searchData3() {
            this.queryData3()
            this.filiterShow3 = false
        },
        searchData4() {
            this.queryData4()
            this.filiterShow4 = false
        },
        //重置条件
        resetFiliter1() {
            this.data1Params = {
                currentPage: 1,
                size: 20,
                orderId: '',
                platformType: '',
                startDate: null,
                endDate: null,
                sort: ''
            }
            this.queryData1()
            this.filiterShow1 = false
        },
        resetFiliter2() {
            this.data2Params = {
                affliateInfo: '',
                platformType: '',
                startDate: null,
                endDate: null,
                currentPage: 1, // 当前页码
                size: 20,
                sort: '',
            }
            this.queryData2()
            this.filiterShow2 = false
        },
        resetFiliter3() {
            this.data3Params = {
                orderId: '',
                startDate: null,
                endDate: null,
                currentPage: 1, // 当前页码
                size: 20,
                sort: '',
            }
            this.queryData3()
            this.filiterShow3 = false
        },
        resetFiliter4() {
            this.data4Params = {
                affliateInfo: '',
                startDate: null,
                endDate: null,
                currentPage: 1,
                size: 20,
                sort: '',
                platformType: '',
            }
            this.queryData4()
            this.filiterShow4 = false
        },
        queryData1() {
            QUERYORDERDETAILLIST(this.data1Params).then(res => {
                if (res.data.body.records) {
                    this.tableData1 = res.data.body.records
                    this.totalpages1 = res.data.body.total
                }
            })
        },
        queryData2() {
            QUERYAFFILIATEDETAILLIST(this.data2Params).then(res => {
                if (res.data.body.records) {
                    this.tableData2 = res.data.body.records
                    this.totalpages2 = res.data.body.total
                }
            })
        },
        queryData3() {
            QUERYREPEATDETAILLIST(this.data3Params).then(res => {
                if (res.data.body.records) {
                    this.tableData3 = res.data.body.records
                    this.totalpages3 = res.data.body.total
                }
            })
        },
        queryData4() {
            QUERYREPEATBDETAILLIST(this.data4Params).then(res => {
                if (res.data.body.records) {
                    this.tableData4 = res.data.body.records
                    this.totalpages4 = res.data.body.total
                }
            })
        },
        scrollData1() {
            this.data1Params.currentPage++
            this.loading1 = true
            QUERYORDERDETAILLIST(this.data1Params).then(res => {
                this.totalpages1 = res.data.body.pages
                let arr = res.data.body.records
                this.tableData1 = this.tableData1.concat(arr)
                this.loading1 = false
            }).catch(err => {
                this.loading1 = false
            })
        },
        scrollData2() {
            this.data2Params.currentPage++
            this.loading2 = true
            QUERYAFFILIATEDETAILLIST(this.data2Params).then(res => {
                this.totalpages2 = res.data.body.pages
                let arr = res.data.body.records
                this.tableData2 = this.tableData2.concat(arr)
                this.loading2 = false
            }).catch(err => {
                this.loading2 = false
            })
        },
        scrollData3() {
            this.data3Params.currentPage++
            this.loading3 = true
            QUERYREPEATDETAILLIST(this.data3Params).then(res => {
                this.totalpages3 = res.data.body.pages
                let arr = res.data.body.records
                this.tableData3 = this.tableData3.concat(arr)
                this.loading3 = false
            }).catch(err => {
                this.loading3 = false
            })
        },
        scrollData4() {
            this.data4Params.currentPage++
            this.loading4 = true
            QUERYREPEATBDETAILLIST(this.data4Params).then(res => {
                this.totalpages4 = res.data.body.pages
                let arr = res.data.body.records
                this.tableData4 = this.tableData4.concat(arr)
                this.loading4 = false
            }).catch(err => {
                this.loading4 = false
            })
        },

        changeTabs() {
            switch (this.activeName) {
                case '1':
                    this.queryData1()
                    break;
                case '2':
                    this.queryData2()
                    break;
                case '3':
                    this.queryData3()
                    break;
                case '4':
                    this.queryData4()
                    break;
                default:
                    return false
            }
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },

    }
}
</script>
<style lang="less" scoped>
.report {
    position: fixed;
    width: 100%;
    height: calc(100% - 50px);
    overflow: hidden;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    padding: 8px;
    background-color: #fff;

    .headerbox {
        display: flex;
        top: 58px;
        width: 100%;
        background-color: #fff;
        z-index: 10;

        .searchbox {
            flex: auto;
        }

        .filiter {
            padding: 5px;

            img {
                width: 35px;
                height: 35px;
            }
        }
    }

    .infinite-list-wrapper {
        margin-top: 8px;
        height: calc(100vh - 172px);

        .scrollbox {
            height: 100%;
            overflow: auto;
        }
    }

    .myfiliter {
        height: 100%;
        width: 100%;
        padding: 8px;
        padding-top: 58px;
        position: relative;

        .title {
            font-weight: 600;
            margin-bottom: 8px;
        }

        .footer {
            padding-top: 8px;
            width: calc(100% - 16px);
            position: absolute;
            bottom: 8px;

            .reset {
                width: 100%;
            }

            .submit {
                width: 100%;
            }
        }
    }

}</style>